/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timepicker__header[_ngcontent-%COMP%]{background-color:#000!important}.clock-face__container[_ngcontent-%COMP%]{--clock-hand-color:black!important}\n/*# sourceMappingURL=material-timepicker.component.css.map*/"];
export { styles as styles };
